import Progress from '.';

/** @type {UICore.ComponentMeta} */
const ProgressComponentMeta = {
  id: 'w-progress',
  name: '进度条',
  icon: 'https://vfiles.gtimg.cn/wuji_dashboard/xy/rainbow/icon-progress_1636364897426.png',
  category: '展示',
  display: 'inline',
  component: Progress,
  propsSchema: {
    type: 'object',
    fields: [{
      id: 'percentage',
      type: 'string',
      title: '进度',
      default: '70'
    }, {
      id: 'color',
      type: 'string',
      title: '颜色',
      default: ''
    }, {
      id: 'type',
      type: 'string',
      title: '风格',
      enum: [{
        label: '进度条',
        value: 'line'
      }, {
        label: '进度圈',
        value: 'circle'
      }, {
        label: '仪表盘',
        value: 'dashboard'
      }]
    }, {
      id: 'text',
      type: 'string',
      title: '文字',
      default: ''
    }, {
      id: 'lineWidth',
      type: 'number',
      title: '线宽',
      default: 6
    }]
  },
  designerFlags: {
    allowAdjustHeight: false
  }
};
export default ProgressComponentMeta;